import {
  FETCH_FG_PURITY_REQUEST,
  FETCH_FG_PURITY_SUCCESS,
  FETCH_FG_PURITY_FAILURE,
  ADD_FG_PURITY_REQUEST,
  ADD_FG_PURITY_SUCCESS,
  ADD_FG_PURITY_FAILURE,
  UPDATE_FG_PURITY_REQUEST,
  UPDATE_FG_PURITY_SUCCESS,
  UPDATE_FG_PURITY_FAILURE,
  DELETE_FG_PURITY_REQUEST,
  DELETE_FG_PURITY_SUCCESS,
  DELETE_FG_PURITY_FAILURE,
  FG_PURITY_FORM_ERROR,
  FG_PURITY_FORM_SUCCESS,
  SET_FG_PURITY_EDIT,
  CLEAR_FG_PURITY_EDIT,
} from '../../../../types/masters/metalPurity/fgPurity/fgPurityTypes';

const initialState = {
  list: [],
  loading: false,
  error: null,
  editingFGPurity: null,
};

const fgPurityReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_FG_PURITY_REQUEST:
    case ADD_FG_PURITY_REQUEST:
    case UPDATE_FG_PURITY_REQUEST:
    case DELETE_FG_PURITY_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_FG_PURITY_SUCCESS:
      return { ...state, loading: false, list: action.payload, error: null };
    case ADD_FG_PURITY_SUCCESS:
    case UPDATE_FG_PURITY_SUCCESS:
    case DELETE_FG_PURITY_SUCCESS:
      return { ...state, loading: false, error: null };
    case FETCH_FG_PURITY_FAILURE:
    case ADD_FG_PURITY_FAILURE:
    case UPDATE_FG_PURITY_FAILURE:
    case DELETE_FG_PURITY_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case FG_PURITY_FORM_ERROR:
      return { ...state, loading: false, formError: action.payload };
    case FG_PURITY_FORM_SUCCESS:
      return { ...state, loading: false, formSuccess: action.payload };
    case SET_FG_PURITY_EDIT:
      return { ...state, editingFGPurity: action.payload };
    case CLEAR_FG_PURITY_EDIT:
      return { ...state, editingFGPurity: null };
    default:
      return state;
  }
};

export default fgPurityReducer; 